const LayoutIcon: React.FC = () => (
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="17" y="1" width="12" height="8" stroke="#1C1C1C" strokeWidth="2" />
    <rect x="13" y="1" width="18" height="12" transform="rotate(90 13 1)" stroke="#1C1C1C" strokeWidth="2" />
    <rect x="17" y="13" width="8" height="6" stroke="#1C1C1C" strokeWidth="2" />
  </svg>
);

export default LayoutIcon;
